<template>
  <div class="partners-page">
    <div class="partners-page__head">
      <h1 class="partners-page__title">{{ $tPartners('Affiliate network') }}</h1>
      <!--      <div class="partners-page__buttons-label d-none d-sm-block">{{ $tPartners('To invite') }}:</div>-->
      <div class="partners-page__head-buttons">
        <button @click.prevent="showRegisterPopup = true"
                type="button"
                class="base-btn base-btn--green">
          <BaseSvg name="ico-plus"
                   width="1.3rem"
                   height="1.3rem"/>
          <span class="base-btn__text">{{ $tPartners('register_agent') }}</span>
        </button>
      </div>
    </div>

    <BasePreloader v-if="pending"/>

    <ErrorView v-if="error"
               :code="error.code"
               :title="error.message"/>


    <div v-else-if="receivedData"
         class="partners-page__content">
      <PartnerPanel :currentPartner="receivedData"
                    class="partners-page__panel"/>

      <PartnerFilter :currentPartner="receivedData"
                     class="partners-page__filter"/>

      <PartnersList :partners="receivedData.network_data"
                    @register-agent="showRegisterPopup = true"
                    @open-agent-registered-show="onShowRegisteredPopup"
                    @open-agent="showRegisteredChangePopupAgent = $event"
                    @refresh="load"
                    class="partners-page__partners-list"/>
    </div>

    <transition name="fade">
      <PartnersRegisterPopup v-if="showRegisterPopup"
                             :callBack="load"
                             @open-agent-registered-show="onShowRegisteredPopup"
                             @close="showRegisterPopup = false"/>
    </transition>

    <transition name="fade">
      <PartnersRegisteredPopup v-if="showRegisteredPopupId"
                               :id="showRegisteredPopupId"
                               @close="showRegisteredPopupId = null"/>
    </transition>

    <transition name="fade">
      <PartnersRegisteredChangePopup v-if="showRegisteredChangePopupAgent"
                                     :agent="showRegisteredChangePopupAgent"
                                     @change="onChangeAgentData"
                                     @close="showRegisteredChangePopupAgent = null"/>
    </transition>
  </div>
</template>

<script>
  import {CancelToken, isCancel} from 'axios'
  import {http} from '@/axios'
  import handleError from '@/helpers/handleError'
  import ErrorView from '@/components/ErrorView'
  import PartnersList from '../../components/partners/PartnersList'
  import PartnerPanel from '@/components/partners/PartnerPanel'
  import PartnerFilter from '@/components/partners/PartnerFilter'
  import PartnersRegisterPopup from '@/components/partners/PartnersRegisterPopup'
  import PartnersRegisteredPopup from '@/components/partners/PartnersRegisteredPopup'
  import PartnersRegisteredChangePopup from '@/components/partners/PartnersRegisteredChangePopup'

  const filterConstants = {
    PARTNERS_DATE_FROM: 'date_from',
    PARTNERS_DATE_TO: 'date_to',
  }

  const formatDate = new Intl.DateTimeFormat('uk', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

  const DEFAULT_DATE_RANGE = getDefaultDateRangeFromDate(new Date())

  function getDefaultDateRangeFromDate(current) {
    const from = new Date(current.getFullYear() - 1, current.getMonth(), current.getDate())
    const to = new Date(current.getFullYear(), current.getMonth(), current.getDate())

    return [formatDate.format(from), formatDate.format(to)]
  }

  export default {
    name: 'AccountPartnersPage',
    components: {
      ErrorView,
      PartnerFilter,
      PartnerPanel,
      PartnersList,
      PartnersRegisterPopup,
      PartnersRegisteredPopup,
      PartnersRegisteredChangePopup,
    },
    provide: {
      ...filterConstants,

      DEFAULT_DATE_RANGE,

      formatDate
    },
    data() {
      return {
        pending: false,
        receivedData: null,

        showRegisterPopup: false,
        showRegisteredPopupId: null,
        showRegisteredChangePopupAgent: null,

        cancel: null,

        ...filterConstants
      }
    },
    methods: {
      load() {
        if (this.cancel) {
          this.cancel()
          this.cancel = null
        }

        this.pending = true
        this.error = null

        const query = this.$route.query
        const params = {}

        for (const key in filterConstants) {
          const paramKey = filterConstants[key]

          params[paramKey] = query[paramKey]
        }

        if (!params[filterConstants.PARTNERS_DATE_FROM]) {
          params[filterConstants.PARTNERS_DATE_FROM] = DEFAULT_DATE_RANGE[0]
        }

        if (!params[filterConstants.PARTNERS_DATE_TO]) {
          params[filterConstants.PARTNERS_DATE_TO] = DEFAULT_DATE_RANGE[1]
        }

        http.get('/api/cabinet/agent/get-network', {
          params,
          cancelToken: new CancelToken((c) => {
            this.cancel = c;
          })
        }).then(({data}) => {
          this.receivedData = data.data
          this.pending = false
        }).catch(e => {
          if (isCancel(e)) {
            return
          }

          this.receivedData = null

          this.error = {
            code: e.response && e.response.status,
            message: handleError(e)
          }

          this.pending = false
        })
      },
      onShowRegisteredPopup(id) {
        this.showRegisteredPopupId = id
      },
      onChangeAgentData(customerData) {
        const index = this.receivedData.network_data.findIndex(d => d.customer_data.id === customerData.id)
        this.$set(this.receivedData.network_data[index], 'customer_data', customerData)
      }
    },
    created() {
      this.load()

      createMapRouteQueryWatchers(
        this,
        Object.values(filterConstants),
        () => {
          this.load()
        }
      )
    }
  }

  function createMapRouteQueryWatchers(vm, keys, callBack) {
    keys.forEach(key => {
      vm.$watch(
        function () {
          return vm.$route.query[key]
        },
        callBack
      )
    })
  }
</script>

<style>

</style>
